export type CampaignBonus = {
  id: string;
  name: string;
  playerMessage: string;
  application: 'first_deposit' | 'every_deposit';
  bonusType: 'fixed' | 'percentage';
  bonusValue: number;
  minDeposit: number;
  maxBonusPerDeposit: number;
  grantedAmount: number;
  reservedAmount: number;
  maxBonusPerPlayer: number | null;
  maxRedemptionsPerPlayer: number | null;
  startsAt: string;
  endsAt: string;
  status: 'draft' | 'active' | 'paused' | 'ended';
};

export function money(amount: number) {
  return `$${amount.toFixed(2)}`;
}

export function bonusLabel(campaign: Pick<CampaignBonus, 'bonusType' | 'bonusValue' | 'maxBonusPerDeposit'>) {
  if (campaign.bonusType === 'fixed') return money(campaign.bonusValue);
  return `${campaign.bonusValue}% up to ${money(campaign.maxBonusPerDeposit)}`;
}

export function slotLabel(
  campaign: Pick<CampaignBonus, 'maxRedemptionsPerPlayer'>,
  grant: { grantedCount?: number; reservedCount?: number }
) {
  if (campaign.maxRedemptionsPerPlayer == null) return 'No limit';
  const granted = grant.grantedCount || 0;
  const held = grant.reservedCount || 0;
  const left = Math.max(0, campaign.maxRedemptionsPerPlayer - granted - held);
  const heldNote = held > 0 ? ` · ${held} held` : '';
  if (left === 0) return `None left${heldNote}`;
  return `${left} left${heldNote}`;
}

export function paidLabel(campaign: Pick<CampaignBonus, 'grantedAmount' | 'reservedAmount'>) {
  const paid = campaign.grantedAmount + campaign.reservedAmount;
  if (campaign.reservedAmount > 0) {
    return `${money(campaign.grantedAmount)} paid · ${money(campaign.reservedAmount)} held`;
  }
  return `${money(paid)} paid`;
}
